<template>
  <div class="flex items-center">
    <div v-if="params.data.photoUrl"><vs-avatar :src="params.data.photoUrl" class="flex-shrink-0 mr-2" size="30px" @click="$router.push(url)" /></div>
    <div v-else><vs-avatar class="rounded-full shadow-md cursor-pointer block" size="40" :text="displayName" :color="color1 < 12 ? 'success' : color1 <= 15 ? 'primary' : color1 <= 20 ? 'warning' : 'danger'" /></div>
    <router-link :to="url" class="text-inherit hover:text-primary">{{ displayUserName }}</router-link>
  </div>
</template>

<script>
export default {
  name: 'CellRendererLink',
  computed: {
    displayUserName () {
      return this.params.value || this.params.data.userName || this.params.data.username || this.params.data.UserName || ''
    },
    displayName () {
      return this.params.data.fullName || this.displayUserName
    },
    url () {
      return `/hris/employeeinformation/${this.params.data.id}`

      // Below line will be for actual product
      // Currently it's commented due to demo purpose - Above url is for demo purpose
      // return "/apps/user/user-view/" + this.params.data.id
    },
    color1(){
      return this.displayName.length
    }

  }
}
</script>
